import { IIdentity } from './common';
import { TRiskLevel } from './riskLevels';
import { TSupplementResponseStatus } from './supplements';

export enum TAdminSupplementInquiryStatus {
  New = 1,
  Recent,
  Other,
}

export interface IAdminSupplementInquiryDetailsDto {
  supplementInquiryId: number;
  submittedOn: string;
  respondedOn: string | null;
  name: string;
  needsAdminResponse: boolean;
  supplementInquiryStatusId: TSupplementResponseStatus;
  adminSupplementInquiryStatusId: TAdminSupplementInquiryStatus;
  isActive: boolean;
}

export type IAdminSupplementInquiryStatus = IIdentity<TAdminSupplementInquiryStatus>;

export interface IAdminSupplementInquiryDetails {
  adminResponseType: number | null;
  adminSupplementInquiryStatusId: TAdminSupplementInquiryStatus;
  comments: string | null;
  drugClassIds: number[] | null;
  ingredients: IIdentity[] | null;
  lastUpdatedBy: string | null;
  lastUpdatedOn: string | null;
  name: string;
  needsAdminResponse: boolean;
  organizationId: number;
  productLink: string | null;
  programCodeId: number;
  riskLevelId: TRiskLevel | null;
  submittedOn: string;
  supplementCategoryId: number | null;
  supplementCompanyId: number | null;
  supplementCompanyName: string | null;
  supplementId: number | null;
  supplementInquiryId: number;
  supplementResponseId: number | null;
  userEnteredSupplementId: number | null;
}

export interface IAdminSupplementInquiryResponseFormValues {
  name: string;
  companyName: string | null;
  drugClassIds: number[] | null;
  ingredients: IIdentity[] | null;
  organizationId: number | null;
  productLink: string | null;
  riskLevelId: TRiskLevel | null;
  supplementCategoryId: number | null;
  supplementCompanyId: number;
  supplementInquiryId: number | null;
  supplementResponseId: number;
  comments: string;
}

export interface IAdminSupplementInquiryResponseValues
  extends Omit<IAdminSupplementInquiryResponseFormValues, 'ingredients'> {
  ingredientIds: number[];
}

export interface IAdminSupplementCreateNewPayload {
  supplementName: string;
  companyName: string;
  supplementCategoryId: number | null;
  linkToProductPage: string;
  supplementInquiryId: number | null;
  drugClassIds: number[] | null;
  ingredientIds: number[] | null;
  riskLevelId: TRiskLevel | null;
  comments: string | null;
}

export interface IAdminSupplementRenewPayload {
  supplementInquiryId: number | null;
  supplementResponseId: number | null;
  supplementCategoryId: number | null;
  supplementCompanyId?: number | null;
  productLink: string;
  name: string;
  drugClassIds: number[] | null;
  ingredientIds: number[] | null;
  riskLevelId: TRiskLevel | null;
  comments: string | null;
}

export interface IAdminSupplementMatchExistingPayload {
  supplementId: number;
  supplementInquiryId: number;
  userEnteredSupplementId: number;
}

export interface IAdminSupplementNeedsMoreInfoPayload {
  supplementInquiryId: number;
  comment: string;
}

export interface IAdminSupplementMarkAsMedicationPayload {
  supplementInquiryId: number;
  comment: string;
}
